import * as style from './style.css';

interface ITooltipTextProps {
  text: string;
}

export const TooltipText = ({ text }: ITooltipTextProps) => {
  return <span className={style['text']}>{text}</span>;
};
